import s from './CTACard.module.css'

type Props = {
  title: string
  description: string
  icon: React.ReactNode
  onClick: () => void
}

export const CTACard: React.FC<Props> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <button type="button" onClick={onClick} className={s.wrapper}>
      <div className={s.details}>
        <div className={s.title}>{title}</div>
        <div className={s.description}>{description}</div>
      </div>
      <div>
        <div className={s.icon}>{icon}</div>
      </div>
    </button>
  )
}
